var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('appointments-item-view',_vm._b({staticClass:"appointment-view",attrs:{"item":_vm.item,"menu-items":_vm.menuItems,"auth-user-id":_vm.authUserId}},'appointments-item-view',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }